export default "__VITE_ASSET__BKtQoshL__"